import { ReactElement } from "react";
import { DrupalArticleDataObject } from "@app/types/Drupal";
import VerticalMostRead from "@components/ArticleCard/VerticalMostRead";
import VerticalBlockTitle from "@components/VerticalBlockTitle/VerticalBlockTitle";
import { VerticalName } from "@util/constant";
import cx from "classnames";

export type MostReadStoriesProps = {
  testId?: string;
  articles: DrupalArticleDataObject[];
  verticalName: VerticalName;
};

export default function MostReadStories({
  testId,
  articles,
  verticalName,
}: MostReadStoriesProps): ReactElement {
  return (
    <>
      {articles?.length > 0 ? (
        <div data-testid={testId}>
          <VerticalBlockTitle text="Most Read" rootClassName="mb-5" />

          <div className="bg-gray-250 p-4">
            {articles?.map(
              (article: DrupalArticleDataObject, index: number) => {
                const spacer =
                  index !== articles.length - 1
                    ? "mb-4 pb-4 border-b border-gray-175"
                    : "";

                return (
                  <div className={cx(spacer)} key={index}>
                    <VerticalMostRead
                      articleData={article}
                      verticalName={verticalName}
                    />
                  </div>
                );
              }
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}
